import React from 'react';
import { inrLakhCrore } from '../../../builder/utils/inrLakhCrore';

/**
 * Wraps a rupee figure; on hover shows it in lakh / crore ("₹78.99 lakh")
 * so long Indian-format numbers can be read at a glance.
 */
const AmountHint = ({ value, children, className = '' }) => {
  const hint = inrLakhCrore(value);
  if (!hint || Math.abs(Number(value)) < 1000) return <>{children}</>;
  return (
    <span className={`group relative inline-block ${className}`}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute left-0 top-full z-30 mt-1 hidden whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs font-semibold text-white shadow-lg group-hover:block">
        {hint}
      </span>
    </span>
  );
};

export default AmountHint;
